import React, { useEffect, useState } from 'react';
export var Status;
(function (Status) {
    Status["LOADING"] = "LOADING";
    Status["FAILURE"] = "FAILURE";
    Status["SUCCESS"] = "SUCCESS";
})(Status || (Status = {}));
var GoogleMapsWrapper = function (_a) {
    var children = _a.children, apiKey = _a.apiKey;
    var _b = useState(Status.LOADING), scriptStatus = _b[0], setScriptStatus = _b[1];
    useEffect(function () {
        var loadScript = function () {
            var script = document.createElement('script');
            script.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey;
            script.async = true;
            script.defer = true;
            script.onload = function () {
                setScriptStatus(Status.SUCCESS);
            };
            script.onerror = function (err) {
                setScriptStatus(Status.FAILURE);
                console.log(err);
            };
            document.head.appendChild(script);
        };
        loadScript();
        return function () {
            var script = document.querySelector('script[src^="https://maps.googleapis.com/maps/api/js"]');
            if (script) {
                script.remove();
            }
        };
    }, [apiKey]);
    if (scriptStatus === Status.SUCCESS && children)
        return React.createElement(React.Fragment, null, children);
    return React.createElement(React.Fragment, null);
};
export default GoogleMapsWrapper;
//# sourceMappingURL=GoogleMapsWrapper.js.map